export { default } from './PagePlaceCategory.vue'
